
export const SPANISH_SPEAKING_COUNTRIES = [
  "MX",
  "ES",
  "CO",
  "PE",
  "PA",
  "CL",
  "AR",
  "SV",
  "GT",
  "HN",
  "PY",
  "BO",
  "EC",
  "DM",
  "CU",
  "CR",
  "VE",
]

function getLanguage(country?: string) {
  if (SPANISH_SPEAKING_COUNTRIES.includes(String(country))) {
    return "es_MX";
  }
  return "en_US";
}

export default getLanguage;
